import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import './Auth.scss'

import logo_cuscapi from '../../assets/images/logo-square.png'
import merchantApi from '../../services/merchantApi'

export default function AuthPage() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('superadmin@app.com')
  const [password, setPassword] = useState('password')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleLogin = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await merchantApi.auth.login({ email, password })
      navigate('/', { replace: true })
    } catch (err) {
      setError(err.message || 'Unable to login. Please check your email and password.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-page__card">
        <div className="auth-page__brand">
          <img src={logo_cuscapi} alt="Logo" height={48}/>
        </div>

        <h1 className="auth-page__title">
          Log in to your account
        </h1>

        <form className="auth-page__form" onSubmit={handleLogin}>
          {error && (
            <div className="auth-page__error">
              {error}
            </div>
          )}

          <div className="auth-page__field">
            <label className="auth-page__label" htmlFor="email">
              Email address
            </label>
            <input
              id="email"
              className="auth-page__input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </div>

          <div className="auth-page__field">
            <label className="auth-page__label" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              className="auth-page__input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          <button className="auth-page__submit" type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Log in'}
          </button>
        </form>
      </div>
    </div>
  )
}
